import { Zones } from '../../../Zone';
import { Widgets } from '../../../Widget';

import { definePlatformVariables } from './deprecatedPlatformVars';
import { GlobalSignage } from './Signage';
import { GlobalAux } from './AuxillaryServices';
import { GlobalPlatform } from './Platform';
import { GlobalReachApi } from './ReachApi';
import { Scheduler } from '../../../Utility/Scheduler';
import { GlobalLog } from './Log';
import { GlobalImageCache } from './ImageCache';
import { enableDevModeApi } from '../DevelopmentEnv';
import { isDevModeEnabled } from '../../../Utility/Environment';
import { LegacyApi, PublicApi, UnstableApi } from './Interface';
import { unstable } from './Unstable';
import { GlobalGlom } from './Glom';
import { Stocks } from './Stocks';
import { Video } from './Video';
import { getPlayerUuid } from '../../../Signage/utility';
import { GlobalMessaging } from './Messaging';

declare global {
    interface Window extends PublicApi, UnstableApi, LegacyApi {
        /** Enable 'Dev Mode' and populate `window` with its functions. */
        enableDevMode: { (): void };
    }
}

window.enableDevMode = enableDevModeApi;
if (isDevModeEnabled()) {
    enableDevModeApi();
}

/* Public API */
window.Messaging = GlobalMessaging;
window.Stocks = Stocks;
window.Video = Video;

/* Unstable API */
window.unstable = unstable;

/* Legacy API */
definePlatformVariables();

window.glom = GlobalGlom;
window.Aux = GlobalAux;
window.Signage = GlobalSignage;
window.Platform = GlobalPlatform;
window.ReachAPI = GlobalReachApi;

window.Scheduler = Scheduler;
window.Log = GlobalLog;
window.ImageCache = GlobalImageCache;

// `REACH` can be added by the C# player, we don't want to overwrite that.
if (typeof window.REACH === 'undefined') {
    window.REACH = {};
}
window.REACH.Player = {
    Uuid: getPlayerUuid(),
};
window.REACH.Zones = Zones;
window.REACH.Widgets = Widgets;
